'use client';

import IconWithLink from '@/components/elements/icon/icon-with-link';
import { CountryCode } from '@/i18n/countries';
import { externalLinks } from '@/utils/constants';
import { createTestId } from '@/utils/string-utils';

const whatsappBase = 'https://api.whatsapp.com/send?phone=%2B';
const viberBase = 'viber://chat/?number=%2B';
// const viberLinkDesktop = `viber://chat/?number=+xxx`;
// const viberLinkMobile = `viber://contact/?number=+xxx`;

const createHeaderTestId = ({ name }: { name: string }) => createTestId({ component: 'header', name });

interface ContactsProps {
    country?: CountryCode;
    size: number;
    is_header?: boolean;
}

export default function Contacts(props: ContactsProps) {
    const viberLink = viberBase + (props.country === 'RU' ? externalLinks.phone_ru : externalLinks.phone);
    const whatsappLink = whatsappBase + (props.country === 'RU' ? externalLinks.phone_ru : externalLinks.phone);

    return (
        <>
            <IconWithLink
                testId={props.is_header ? createHeaderTestId({ name: 'telegram-link' }) : undefined}
                size={props.size}
                ariaLabel="Contact us via telegram"
                icon={'bg-telegram'}
                href={externalLinks.telegram}
            />
            <IconWithLink
                testId={props.is_header ? createHeaderTestId({ name: 'instagram-link' }) : undefined}
                size={props.size}
                ariaLabel="Link to Instagram"
                icon={'bg-instagram'}
                href={externalLinks.instagram}
            />
            <IconWithLink
                testId={props.is_header ? createHeaderTestId({ name: 'email-link' }) : undefined}
                size={props.size}
                ariaLabel="Contact us via email"
                icon={'bg-mail'}
                href={`mailto:${externalLinks.email}`}
            />
            <IconWithLink
                testId={props.is_header ? createHeaderTestId({ name: 'viber-link' }) : undefined}
                size={props.size}
                ariaLabel="Contact us via Viber"
                icon={'bg-viber'}
                href={viberLink}
                fallbackUrl={externalLinks.viber_download}
            />
            <IconWithLink
                testId={props.is_header ? createHeaderTestId({ name: 'whatsapp-link' }) : undefined}
                size={props.size}
                ariaLabel="Contact us via WhatsApp"
                icon={'bg-whatsapp'}
                href={whatsappLink}
            />
        </>
    );
}
